import React from "react";

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative pt-[160px] md:pt-[200px] pb-24 md:pb-32 overflow-hidden tb-hero-glow"
        >
            <div className="absolute inset-0 tb-dot-grid opacity-40 pointer-events-none" />

            <div className="relative max-w-6xl mx-auto px-6 md:px-10 text-center">
                <p
                    data-testid="hero-lead"
                    className="tb-reveal text-[var(--tb-text-body)] text-sm md:text-base lg:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed"
                    style={{ animationDelay: "60ms" }}
                >
                    No pilot flies a plane without a{" "}
                    <span
                        className="italic"
                        style={{ color: "var(--tb-gold-muted)" }}
                    >
                        pre-flight check.
                    </span>
                </p>

                <h1
                    data-testid="hero-headline"
                    className="font-display text-white font-extrabold tb-reveal text-[40px] leading-[1.05] sm:text-[60px] md:text-[80px] lg:text-[96px] tracking-[-0.03em]"
                    style={{ animationDelay: "180ms" }}
                >
                    Why are you placing{" "}
                    <br className="hidden sm:block" />
                    <span style={{ color: "var(--tb-gold)" }}>
                        $100 parlays
                    </span>{" "}
                    without a{" "}
                    <span className="italic font-medium">Tiltbox audit?</span>
                </h1>

                <p
                    data-testid="hero-pitch"
                    className="tb-reveal mt-10 md:mt-12 text-[var(--tb-text-body)] text-base md:text-xl leading-relaxed max-w-3xl mx-auto"
                    style={{ animationDelay: "280ms" }}
                >
                    Tiltbox shows you the{" "}
                    <span className="text-white font-semibold">
                        most favorable outcome
                    </span>{" "}
                    —{" "}
                    <span style={{ color: "var(--tb-gold-muted)" }}>
                        over or under
                    </span>{" "}
                    — before you press{" "}
                    <span className="text-white font-semibold">
                        place the bet.
                    </span>
                </p>

                <div
                    data-testid="hero-actions"
                    className="tb-reveal mt-14 flex flex-col sm:flex-row items-center justify-center gap-4"
                    style={{ animationDelay: "360ms" }}
                >
                    <a
                        href="https://apps.apple.com/us/app/tiltbox-io/id6761959954"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="hero-cta-primary"
                        className="tb-cta"
                    >
                        See what Tiltbox audits
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </a>
                </div>

                <div
                    className="tb-reveal mt-20 flex items-center justify-center gap-8 opacity-60"
                    style={{ animationDelay: "520ms" }}
                    data-testid="hero-trust-row"
                >
                    <span className="text-[10px] tracking-[0.3em] uppercase text-[var(--tb-text-dim)]">
                        Built for the disciplined bettor
                    </span>
                </div>
            </div>
        </section>
    );
}
